import { render, staticRenderFns } from "./TeamMemberDetailsEditModal.vue?vue&type=template&id=bbc2e1ba&scoped=true&"
import script from "./TeamMemberDetailsEditModal.vue?vue&type=script&lang=ts&"
export * from "./TeamMemberDetailsEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMemberDetailsEditModal.vue?vue&type=style&index=0&id=bbc2e1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc2e1ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc2e1ba')) {
      api.createRecord('bbc2e1ba', component.options)
    } else {
      api.reload('bbc2e1ba', component.options)
    }
    module.hot.accept("./TeamMemberDetailsEditModal.vue?vue&type=template&id=bbc2e1ba&scoped=true&", function () {
      api.rerender('bbc2e1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TeamMemberDetailsEditModal.vue"
export default component.exports